import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/services/config-service';
import { HttpClientWrapperService } from 'src/app/services/http-client-wrapper.service';

@Injectable()
export class LogsDataService {

  constructor(
     public http: HttpClientWrapperService,
    private config: ConfigService
  ) { }

  getLCOList(): Observable<any> {
    const url = this.config.json.apiEndpointRdbms + 'lco/getLCOs' +  this.config.json.apiEndpointSuffix;
    return this.http.get(url);
  }

  // getChannelList(): Observable<any> {
  //   const url = this.config.json.apiEndpointRdbms + 'channel/getChannels' +  this.config.json.apiEndpointSuffix;
  //   return this.http.get(url);
  // }

  getChannelList(): Observable<any> {
    const url = this.config.json.apiEndpointRdbms + 'getChannelInfoList' + this.config.json.apiEndpointSuffix;
    return this.http.get(url);
  }

  getAlaCarteChannelList(): Observable<any> {
    const url = this.config.json.apiEndpointRdbms + 'getAlaCarteChannelInfoList' + this.config.json.apiEndpointSuffix;
    return this.http.get(url);
  }

  getBouquetList(): Observable<any> {
    const url = this.config.json.apiEndpointRdbms + 'getBouquetInfoList' + this.config.json.apiEndpointSuffix;
    return this.http.get(url);
  }



  getCompleteLog(from: any, to: any, body: any): Observable<any> {
    body['fromDate'] = from.format('YYYY-MM-DD');
    body['toDate'] = to.format('YYYY-MM-DD');
    const url = this.config.json.apiEndpointRdbms + 'getCompleteLog' +  this.config.json.apiEndpointSuffix;
    return this.http.post(url, body);
  }

  getActDeactLog(from: any, to: any, body: any): Observable<any> {
    body['fromDate'] = from.format('YYYY-MM-DD');
    body['toDate'] = to.format('YYYY-MM-DD');
    const url = this.config.json.apiEndpointRdbms + 'getStbActivationDeactivationLog' +  this.config.json.apiEndpointSuffix;
    return this.http.post(url, body);
  }

  getSubActDeactLog(from: any, to: any, body: any): Observable<any> {
    body['fromDate'] = from.format('YYYY-MM-DD');
    body['toDate'] = to.format('YYYY-MM-DD');
    const url = this.config.json.apiEndpointRdbms + 'getSubscriberActivationDeactivationLog' +  this.config.json.apiEndpointSuffix;
    return this.http.post(url, body);
  }

  getBouquetSubsDesubsLog(from: any, to: any, body: any): Observable<any> {
    body['fromDate'] = from.format('YYYY-MM-DD');
    body['toDate'] = to.format('YYYY-MM-DD');
    const url = this.config.json.apiEndpointRdbms + 'getBouquetSubsDesubsLog' +  this.config.json.apiEndpointSuffix;
    return this.http.post(url, body);
  }

  getAlaCarteSubsDesubsLog(from: any, to: any, body: any): Observable<any> {
    body['fromDate'] = from.format('YYYY-MM-DD');
    body['toDate'] = to.format('YYYY-MM-DD');
    const url = this.config.json.apiEndpointRdbms + 'getAlaCarteSubsDesubsLog' +  this.config.json.apiEndpointSuffix;
    return this.http.post(url, body);
  }

  getBouquetModificationLog(from: any, to: any, bouquetId: any, body: any): Observable<any> {
    body['fromDate'] = from.format('YYYY-MM-DD');
    body['toDate'] = to.format('YYYY-MM-DD');
    body['bouquet_id'] = bouquetId;
    const url = this.config.json.apiEndpointRdbms + 'getBouquetModificationLog' +  this.config.json.apiEndpointSuffix;
    return this.http.post(url, body);
  }

  getChannelModificationLog(from: any, to: any, channelId: any, body: any): Observable<any> {
    body['fromDate'] = from.format('YYYY-MM-DD');
    body['toDate'] = to.format('YYYY-MM-DD');
    body['channel_id'] = channelId
    const url = this.config.json.apiEndpointRdbms + 'getChannelModificationLog' +  this.config.json.apiEndpointSuffix;
    return this.http.post(url, body);
  }

  getAlaCarteModificationLog(from: any, to: any, channelId: any, body: any): Observable<any> {
    body['fromDate'] = from.format('YYYY-MM-DD');
    body['toDate'] = to.format('YYYY-MM-DD');
    body['channel_id'] = channelId;
    const url = this.config.json.apiEndpointRdbms + 'getAlaCarteModificationLog' + this.config.json.apiEndpointSuffix;
    return this.http.post(url, body);
  }

}
